(function () {
    'use strict';

    angular
        .module('app')
        .controller('SubjectsEditController', SubjectsEditController);

    SubjectsEditController.$inject = ['debug', '$stateParams', 'i18n', 'API', 'helpers', '$state', 'alert',];

    function SubjectsEditController(debug, $stateParams, i18n, API, helpers, $state, alert) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.openRemoveModal = openRemoveModal;
        vm.subject = null;
        vm.loadingState = {
            subjectIsLoading: false
        };
        vm.now = helpers.getDatabaseDatetime();

        activate();

        function activate() {
            loadSubject();
        }

        function loadSubject() {
            vm.loadingState.subjectIsLoading = true;
            API.Subject.get({ id: vm.id, expand: 'badges,segments' }).$promise.then(function (response) {
                debug.log(response);
                vm.subject = response;
                vm.loadingState.subjectIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            vm.subject.$save().then(function (response) {
                if (response.id) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadSubject();
                }
            }, function () {
            })
            .finally(function() {
                vm.isSaving = false;
            });
        }

        function openRemoveModal() {
            var promise = alert.confirm('remove-item');

            promise.then(function () {
                var removePromise = API.Subject.delete({ id: vm.id }).$promise;

                removePromise.then(function () {
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('SUBJECT_REMOVED') });
                    $state.go('subjects.list');
                }, function () {
                });
            }, function () {
            });
        }
    }
})();